import Select, { IItemList } from "../core/Select";
import React from "react";
import classes from "./pageSize.module.css";

interface IProps {
  pageSize: string | null;
  pageSizeList: IItemList[];
  page: number;
  itemsCount: number;
  onChange: (pageSize: string | null) => void;
}

const PageSize = ({ pageSize, pageSizeList, page, itemsCount, onChange }: IProps) => {
  const offset = (page - 1) * Number(pageSize) + 1;

  let countOnPage = page * Number(pageSize);
  if (countOnPage > itemsCount) {
    countOnPage = itemsCount;
  }

  return (
    <div className={classes.pageSize}>
      <Select value={pageSize} list={pageSizeList} onChange={onChange} />
      <span>{offset} - {countOnPage} of {itemsCount}</span>
    </div>
  );
};

export default PageSize;
